(function (angular) {
    'use strict';

    angular.module('app')
        .service('NewsApi', newsResource);

    newsResource.$inject = [
        'settings',
        '$resource',
        'extendResource'
    ];

    function newsResource(
        settings,
        $resource,
        extendResource
    ) {
        /**
         * Adds extra methods and values. Expectes "this" to be bound to an item object
         * @return {this}
         */
        function transform() {
            // Add placeholder image
            if (this.img === undefined || this.img === null) {
                this.img = 'https://placeimg.com/500/160/nature';
            }

            return this;
        }

        // Create the resource
        var resource = $resource(settings.apiBase + '/posts/:id', {
            type: 'news',
        }, {
            get: {
                method: 'GET',
                responseType: 'json',
                transformResponse: function (response) {
                    if (typeof response === 'string') {
                        response = JSON.parse(response);
                    }

                    if (Array.isArray(response.data)) {
                        angular.forEach(response.data, function (item) {
                            transform.call(item);
                        });
                    } else {
                        transform.call(response.data);
                    }

                    return response;
                }
            },
            post: {
                method: 'POST',
                responseType: 'json'
            },
            update: {
                params: {
                    id: '@id'
                },
                method: 'PUT',
                responseType: 'json'
            }
        });
        resource.prototype.transform = transform;

        return extendResource(resource);
    }

}(angular));
